<script>
import VueJsModal from './Modal.vue';

export default {
	extends: VueJsModal
};
</script>
